import { Component } from '@angular/core';

@Component({
  selector: 'icon-full-screen',
  standalone: true,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M20 4H28M28 4V12M28 4L18.6667 13.3333M12 28H4M4 28V20M4 28L13.3333 18.6667" stroke="#F8F9FA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `,
  styles: `
    @import '../assets/colors.scss';

    svg{
        cursor: pointer;
        path{
          stroke: $text_header_color
        }
    }
  `
})

export class FullScreenIconComponent {}
